import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "page" }

import { computed, onMounted } from 'vue'
import { RouterView } from 'vue-router'
import Header from './components/Header/Header.vue'
import './assets/css/ck-editor.css'
import './assets/css/style.css'
import store from '@/store'
import AddCategorySuccessfully from './components/AddCategorySuccessfully.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  store.dispatch('getUserCurrent')
  store.dispatch('setCardItem', undefined)
})

const isAlertVisible = computed(() => store.getters.isAlertShown)
const getAlertMessage = computed(() => store.getters.getAlertMessage)
const getAlertType = computed(() => store.getters.getAlertType)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "badgeinfo" }, {
        default: _withCtx(() => [
          (_unref(isAlertVisible))
            ? (_openBlock(), _createBlock(AddCategorySuccessfully, {
                key: 0,
                messageSave: _unref(getAlertMessage),
                type: _unref(getAlertType)
              }, null, 8, ["messageSave", "type"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(Header),
      _createVNode(_unref(RouterView), { class: "padding-top" })
    ])
  ]))
}
}

})